import SmallViewMenu from './SmallViewMenu';

export default SmallViewMenu;
